import type { formattedError } from 'app/typings/error';

import { assertNever } from '../typing';

export enum HotelErrorCode {
  CANNOT_SWITCH_TO_MULTI_RATE_WITH_MULTI_PACKAGE = 'cannotSwitchToMultiRateWithMultiPackage',
  DUPLICATE_PICTURES_HOTEL = 'DuplicatePicturesHotels',
}

export const retrieveHotelErrorMessage = (
  errorCode: HotelErrorCode
): formattedError => {
  switch (errorCode) {
    case HotelErrorCode.CANNOT_SWITCH_TO_MULTI_RATE_WITH_MULTI_PACKAGE:
      return {
        errorTitle:
          "You cannot change this hotel's connected rates to BAR + Staycation rate",
        errorMessage:
          'The hotel should only have 1 published package in order to use this connectivity.',
      };
    case HotelErrorCode.DUPLICATE_PICTURES_HOTEL:
      return {
        errorTitle: 'You cannot have the same picture twice',
        errorMessage:
          'The pictures have to be distinct between Introduction and Rooms',
      };

    default:
      return assertNever(errorCode);
  }
};
